import omit from "lodash/omit";
import { CustomType, CustomValuePreview, Id } from "PFTypes";
import { Dispatch, PropsWithChildren, SetStateAction, useEffect, useState } from "react";

import { useCustomValuePreviewData } from "../use_custom_value_preview";
import { CustomValuePreviewContext } from "./custom_value_preview_context";

type CustomValuePreviewContextType = Omit<CustomValuePreview, "customValueId"> & {
  customType: CustomType;
  allowSearch: boolean;
  customValueId: Id | null;
  setSelectedCustomValueId: Dispatch<SetStateAction<Id | null>>;
  show: boolean;
  isClosing: boolean;
  index: number;
};

export const CustomValuePreviewContextProvider = ({
  children,
  customType
}: PropsWithChildren<Pick<CustomValuePreviewContextType, "customType">>) => {
  const { data: customValuePreview, isOpen: show, isClosing = false, index } = useCustomValuePreviewData();

  const {
    customValueId: initialCustomValueId = null,
    allowSearch = false,
    canRemove = true,
    key
  } = customValuePreview;

  const [selectedCustomValueId, setSelectedCustomValueId] = useState<Id | null>(null);

  useEffect(() => {
    setSelectedCustomValueId(null);
  }, [initialCustomValueId, key]);

  return (
    <CustomValuePreviewContext.Provider
      value={{
        ...omit(customValuePreview, "customValueId"),
        show,
        isClosing,
        index,
        customType,
        allowSearch,
        canRemove,
        customValueId: allowSearch ? selectedCustomValueId : initialCustomValueId,
        setSelectedCustomValueId
      }}
    >
      {children}
    </CustomValuePreviewContext.Provider>
  );
};
